import { render, staticRenderFns } from "./MoviePostersModal.vue?vue&type=template&id=12c354e6&scoped=true&"
import script from "./MoviePostersModal.vue?vue&type=script&lang=js&"
export * from "./MoviePostersModal.vue?vue&type=script&lang=js&"
import style0 from "./MoviePostersModal.vue?vue&type=style&index=0&id=12c354e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c354e6",
  null
  
)

export default component.exports